import Link from 'next/link';
import ContentStackImage from '@/components/customercenter-ui/common/contentStackImage/contentStackImage';
import NoImage from '@/components/customercenter-ui/svgs/noImage';
import { addFromOrderParam } from '../../util';
const ProductItem = ({ Texts, productDetails }: any) => {
  const productImage = productDetails?.imageUrl ? (
    <ContentStackImage
      className="w-full"
      src={productDetails?.imageUrl}
      imageWidth={90}
      imageHeight={90}
      alt={`Product Image ${productDetails?.lineSequence}`}
      loading="eager"
    />
  ) : (
    <NoImage className="h-[90px] w-[90px]" />
  );
  return (
    <div className="flex items-center gap-4">
      {productDetails?.pdpUrl ? (
        <Link
          prefetch={false}
          href={addFromOrderParam(productDetails?.pdpUrl || '')}
          passHref
          title={productDetails?.productDetails ?? ''}
        >
          {productImage}
        </Link>
      ) : (
        productImage
      )}
      <div className="flex flex-col flex-wrap">
        {productDetails?.pdpUrl ? (
          <Link
            prefetch={false}
            href={addFromOrderParam(productDetails?.pdpUrl || '')}
            passHref
            title={productDetails?.productDetails ?? ''}
          >
            <p className="text-14 font-semibold text-black hover:underline">{productDetails?.productDetails}</p>
          </Link>
        ) : (
          <p className="text-14 font-semibold text-black">{productDetails?.productDetails}</p>
        )}

        <p>
          {Texts.itemNumber}: {productDetails?.itemNumber}
        </p>
        <p>{productDetails?.color}</p>
        <p>
          {Texts.Qty}: {productDetails?.qty}
        </p>
      </div>
    </div>
  );
};

export default ProductItem;
